import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import styled from 'styled-components';

import ProgressTracker from '@ui-parts/ProgressTracker';

import { PALETTE, FONT_SIZES } from '~/assets/styles/base';
import { ROUTES } from '~/constants/routes';
import { PROGRESS_TRACKER_LABELS, PROGRESS_TYPE, USER_REGISTRATION_PROGRESSES } from '~/constants';

const StyledBox = styled.div`
  background: ${PALETTE.white};
  width: 720px;
  border: 1px solid ${PALETTE.border.frame};
  margin: 55px auto;
  padding: 55px 50px;
  text-align: center;
  white-space: pre-line;
`;

const StyledIcon = styled(ForwardToInboxIcon)`
  color: ${PALETTE.text.primary};
  font-size: 40px;
`;

// ユーザ仮登録完了画面
const SignupCompleted = () => {
  const { t } = useTranslation();

  return (
    <>
      <ProgressTracker
        width="618px"
        labels={(PROGRESS_TRACKER_LABELS as Record<string, Array<string>>)[
          PROGRESS_TYPE.USER_REGISTRATION
        ].map((label) => t(label))}
        currentNum={USER_REGISTRATION_PROGRESSES[ROUTES.USER.SIGNUP_COMPLETED]}
      />

      <StyledBox>
        <StyledIcon />
        <Typography
          sx={{ fontSize: FONT_SIZES.body3, color: PALETTE.text.primary, paddingTop: '10px' }}
          data-testid="pages-signupcompleted-title"
        >
          {t('appCommon.confirm')}
        </Typography>
        <Typography
          sx={{ fontSize: FONT_SIZES.body1, color: PALETTE.text.primary, paddingTop: '10px' }}
          data-testid="pages-signupcompleted-message"
        >
          {t('registration.mailSent')}
        </Typography>
        <Typography
          sx={{ fontSize: FONT_SIZES.bodyDefault, paddingTop: '10px' }}
          data-testid="pages-signupcompleted-desc"
        >
          {t('registration.mailMessage')}
        </Typography>
      </StyledBox>
    </>
  );
};

export default SignupCompleted;
